
































import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'NavigationDrawerTabs',

  data: () => ({
    tab: 0,
    tabs: [
      {
        icon: 'mdi-magnify',
        text: 'Browse',
        type: 'tab',
        path: '/home',
      },
      {
        icon: 'mdi-filmstrip',
        text: 'Movies',
        type: 'tab',
        path: '/movies',
      },
      {
        icon: 'mdi-television',
        text: 'TV Shows',
        type: 'tab',
        path: '/shows',
      },
      {
        text: 'divider1',
        type: 'divider',
      },
      {
        icon: 'mdi-folder-table-outline',
        text: 'My Categories',
        type: 'tab',
        path: '/category',
      },
      {
        icon: 'mdi-message-draw',
        text: 'My Reviews',
        type: 'tab',
        path: '/review',
      },
      {
        text: 'divider2',
        type: 'divider',
      },
      {
        icon: 'mdi-logout',
        text: 'Logout',
        type: 'tab',
        path: '/logout',
      },
    ],
  }),

  methods: {
    ...mapActions('user', [
      'logout',
    ]),

    changePage() {
      let index = this.tab;
      if (index >= 3) {
        index += 1;
      }
      if (index >= 6) {
        index += 1;
      }
      const path = this.tabs[index].path as string;

      if (path === '/logout') {
        this.logout();
      } else {
        this.$router.push(path);
      }
    },
  },
});
